import { IDSNotificationBadge as i } from "./notification-badge-element.js";
import { registerComponent as t } from "../../../utilities/utils.js";
t("ids-notification-badge", i);